import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { carregarErpsSistema } from "./services/erpSistema";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Descobre uma vez quais ERPs o sistema usa (services/erpSistema) antes de
// renderizar, para que qualquer tela já leia o valor de forma síncrona. Nunca
// falha: sem backend, usa REACT_APP_ERP.
carregarErpsSistema().finally(() => {
	root.render(
		<React.StrictMode>
			<App />
		</React.StrictMode>
	);
});

reportWebVitals();
